// 第六页到第七页之间添加 校验"联系人和联系方式"与法人信息是否一致
<template>
  <div class="sign-content">
    <!-- 验证类型：1-法人验证 2-代理人验证 -->
    <div 
      class="verifyOne" 
      v-if="
        verifyResultBo.verifyType == 1
      "
    >
      <!-- 人脸未认证 -->
      <div
        class="verify-cotent"
        v-if="
          (verifyResultBo.identityVerifyResult == null || 
            verifyResultBo.identityVerifyResult == 0) ||
            verifyResultBo.identityVerifyResult == 3 ||
            verifyResultBo.identityVerifyResult == 4
        "
      >
        <!-- 标题 -->
        <div class="verify-one-title">
          身份验证
        </div>

        <!-- 二维码区域 -->
        <div class="qrcode-box-large">
          <img v-if="qrcodeUrl" :src="qrcodeUrl" class="qrcode-img" alt="二维码" />
          <span v-else class="qrcode-placeholder">二维码</span>
        </div>

        <!-- 三个小图标 -->
        <div class="scan-icons">
          <div class="scan-icon-item wx"></div>
          <div class="scan-icon-item qq"></div>
          <div class="scan-icon-item zfb"></div>
        </div>

        <!-- 扫描提示 -->
        <div class="scan-tip">使用微信、QQ、支付宝或浏览器扫一扫</div>
        <div class="verify-warning">为确保签署人身份真实有效，本次签署结果具有法律效力。</div>
          <div style="margin-bottom: 20px;" v-if="verifyResultBo.identityVerifyResult == 3">
            <span style="color: red;">扫码完成后点击下方刷新按钮查询验证结果</span>
          </div>
        <el-button 
          v-if="verifyResultBo.identityVerifyResult == 4"
          class="refresh-btn" 
          @click="restVerify"
        >重新验证</el-button>

        <!-- 底部按钮 -->
        <div class="verify-footer">
          <el-button class="refresh-btn refresh-result-btn" @click="refreshVerify">刷新认证结果</el-button>
          <div class="btnBox">
            <el-button
              class="left-btn btn"
              size="mini"
              type="primary-icon-medium"
              @click="goPreviousStep()"
            >
              <span>{{ $t('basicLayout.btn')[0] }}</span>
            </el-button>
          </div>
        </div>
      </div>
      <!-- 人脸已认证 通过 -->
      <div
        class="verify-cotent"
        v-if="
          verifyResultBo.identityVerifyResult == 1
        "
      >
        <!-- 认证成功图标 + 文字 -->
        <div class="success-box">
          <img src="../../../../assets/images/through.png" class="success-img success-img-large" alt="认证通过" />
          <div class="success-title">认证通过</div>
        </div>

        <div class="verify-warning">为确保签署人身份真实有效，本次签署结果具有法律效力。</div>

        <!-- 倒计时提示 -->
        <!-- <div class="countdown-tip">{{ countdown }}秒后自动进入下一步</div> -->

        <!-- 底部按钮 -->
        <div class="verify-footer">
          <div class="btnBox">
            <el-button
              class="right-btn btn"
              size="mini"
              type="primary-icon-medium"
              @click="goNext()"
            >
              <span>{{ $t('basicLayout.btn')[1] }}</span>
            </el-button>
          </div>
        </div>
      </div>
      <!-- 人脸已认证 失失败 -->
      <div
        class="verify-cotent"
        v-if="
          verifyResultBo.identityVerifyResult == 2
        "
      >
        <!-- 认证失败图标 -->
        <div class="failure-icon-wrapper">
          <i class="el-icon-error"></i>
        </div>

        <!-- 认证失败文字 -->
        <div class="failure-title verifyRightTitle">认证失败</div>
        <div class="verify-warning">为确保签署人身份真实有效，本次签署结果具有法律效力。</div>
        <el-button class="refresh-btn" @click="restVerify">重新验证</el-button>

        <!-- 倒计时提示 -->
        <!-- <div class="failure-countdown-tip">{{ failureCountdown }}秒后即将返回注册页面</div> -->
        <div class="btnBox">
          <el-button
            class="left-btn btn"
            size="mini"
            type="primary-icon-medium"
            @click="goPreviousStep()"
          >
            <span>{{ $t('basicLayout.btn')[0] }}</span>
          </el-button>
        </div>
      </div>
    </div>
    <!-- 验证类型：1-法人验证 2-代理人验证 -->
    <div 
      class="verifyTow" 
      v-if="
        verifyResultBo.verifyType == 2
      "
    >
      <!-- 左右两栏布局 -->
      <div class="verify-container">
        <!-- 左侧：二维码身份验证 -->
        <!-- 人脸未认证 -->
        <div 
          class="verify-left" 
          v-if="
            verifyResultBo.verifyType == 2 &&
            ((verifyResultBo.identityVerifyResult == null || 
            verifyResultBo.identityVerifyResult == 0) ||
            verifyResultBo.identityVerifyResult == 3 ||
            verifyResultBo.identityVerifyResult == 4)
          "
        >
          <div class="verify-title">身份验证</div>
          <div class="qrcode-box">
            <img v-if="qrcodeUrl" :src="qrcodeUrl" class="qrcode-img" alt="二维码" />
            <span v-else class="qrcode-placeholder">二维码</span>
          </div>
          <div class="scan-icons">
            <div class="scan-icon-item wx"></div>
            <div class="scan-icon-item qq"></div>
            <div class="scan-icon-item zfb"></div>
          </div>
          <div class="scan-tip">使用微信、QQ、支付宝或浏览器扫一扫</div>
          <!-- 红色提示文字移至左侧底部 -->
          <div class="verify-warning">为确保签署人身份真实有效，本次签署结果具有法律效力。</div>
          <div style="margin-top: 20px;" v-if="verifyResultBo.identityVerifyResult == 3">
            <span style="color: red;">身份验证中, 完成后点击下方刷新按钮查询验证结果</span>
          </div>
          <el-button 
            v-if="verifyResultBo.identityVerifyResult == 4"
            class="refresh-btn" 
            @click="restVerify"
          >重新验证</el-button>
        </div>
        <!-- 人脸认证成功 -->
        <!-- 左侧：身份验证通过 -->
        <div 
          class="verify-left"
          v-else-if="
            verifyResultBo.verifyType == 2 && 
            verifyResultBo.identityVerifyResult == 1
          "
        >
          <div class="verify-title">身份验证</div>
          <div class="success-box">
            <img src="../../../../assets/images/through.png" class="success-img" alt="认证通过" />
            <div class="success-text">认证通过</div>
          </div>
          <div class="verify-warning">为确保签署人身份真实有效，本次签署结果具有法律效力。</div>
        </div>
        <!-- 人脸认证失败 -->
        <!-- 左侧：身份验证失败 -->
        <div 
          class="verify-left"
          v-else-if="
            verifyResultBo.verifyType == 2 && 
            verifyResultBo.identityVerifyResult == 2
          "
        >
          <div class="verify-title">身份验证</div>
          <div class="failure-icon">
            <i class="el-icon-error"></i>
          </div>
          <div class="failure-text">认证失败</div>
          <!-- 认证失败原因 -->
          <div class="failure-reason">认证失败原因：<span style="color: red;">{{ verifyResultBo.identityVerifyFailReason }}</span></div>
          <div class="verify-warning">为确保签署人身份真实有效，本次签署结果具有法律效力。</div>
          <el-button class="refresh-btn" @click="restVerify">重新验证</el-button>
        </div>

        <!-- 中间分割线 -->
        <div class="verify-divider"></div>

        <!-- 右侧：上传授权委托书 -->
        <!-- 未验证 -->
        <div 
          class="verify-right"
          v-if="
            verifyResultBo.verifyType == 2 &&
            ((verifyResultBo.entrustVerifyResult == null || 
            verifyResultBo.entrustVerifyResult == 0) ||
            verifyResultBo.entrustVerifyResult == 3)
          "
        >
          <div class="verify-title required">上传加盖企业公章的官方授权委托书</div>
          <el-upload
            ref="upload"
            class="auth-upload upload-demo"
            :action="uploadUrl"
            :before-upload="beforeUpload"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :limit="1"
            accept=".jpg,.jpeg,.png,.pdf"
            :file-list="fileList"
          >
            <div class="no-fileInfo">
              <img src="../../../../assets/images/upload01.png" class="upload-icon-img" alt="上传" />
              <div class="el-upload__text upload-text">
                上传
              </div>
            </div>
          </el-upload>
          <div class="upload-tip">支持图片、PDF格式</div>
          <div class="download-template" @click="downloadTemplate">下载委托书模版</div>
          <div style="margin-top: 20px;" v-if="verifyResultBo.entrustVerifyResult == 3">
            <span style="color: red;">授权委托书认证中, 等待5秒后点击下方刷新按钮</span>
          </div>
        </div>
        <!-- 右侧：授权委托书上传通过 -->
        <!-- 通过 -->
        <div 
          class="verify-right"
          v-else-if="
            verifyResultBo.verifyType == 2 && 
            (verifyResultBo.entrustVerifyResult == 1 ||
            verifyResultBo.entrustVerifyResult == 3)
          "
        >
          <div class="verify-title required">上传加盖企业公章的官方授权委托书</div>
          <div class="success-box">
            <img src="../../../../assets/images/through.png" class="success-img" alt="认证通过" />
            <div class="success-text">认证通过</div>
          </div>
        </div>
        <!-- 右侧：授权委托书上传通过 -->
        <!-- 未通过 -->
        <div 
          class="verify-right"
          v-else-if="
            verifyResultBo.verifyType == 2 && 
            (verifyResultBo.entrustVerifyResult == 2 ||
            verifyResultBo.entrustVerifyResult == 3)
          "
        >
          <div class="verify-title required">上传加盖企业公章的官方授权委托书</div>
          <!-- 认证失败图标 -->
          <div class="failure-icon-wrapper">
            <i class="el-icon-error"></i>
          </div>

          <!-- 认证失败文字 -->
          <div class="failure-title verifyRightTitle">认证失败</div>
          <!-- 认证失败原因 -->
          <div class="failure-reason">认证失败原因：<span style="color: red;">{{ verifyResultBo.entrustVerifyFailReason }}</span></div>
          <el-button 
            v-if="verifyResultBo.entrustVerifyResult != 3"
            class="refresh-btn" 
            @click="restUpLoad"
          >重新上传</el-button>
        </div>
      </div>

      <!-- 底部按钮 -->
      <!-- 都未认证 -->
      <div 
        class="verify-footer"
        v-if="
          verifyResultBo.identityVerifyResult != 1 || 
          verifyResultBo.entrustVerifyResult != 1
        "
      >
        <el-button class="refresh-btn refresh-result-btn" @click="refreshVerify">刷新认证结果</el-button>
        <div 
          class="btnBox"
        >
          <el-button
            class="left-btn btn"
            size="mini"
            type="primary-icon-medium"
            @click="goPreviousStep()"
          >
            <span>{{ $t('basicLayout.btn')[0] }}</span>
          </el-button>
        </div>
      </div>
      <!-- 底部倒计时和按钮 -->
      <!-- 都已认证成功 -->
      <div 
        class="verify-footer"
        v-if="
          verifyResultBo.identityVerifyResult == 1 && 
          verifyResultBo.entrustVerifyResult == 1
        "
      >
        <!-- <div class="countdown-tip">{{ countdown }}秒后自动进入下一步</div> -->
        <!-- <el-button class="next-btn" @click="goNext">下一步</el-button> -->
        <div class="btnBox">
          <el-button
            class="right-btn btn"
            size="mini"
            type="primary-icon-medium"
            @click="goNext()"
          >
            <span>{{ $t('basicLayout.btn')[1] }}</span>
          </el-button>
        </div>
      </div>
      <!-- 底部倒计时 -->
      <!-- 任意一个认证失败或未通过 -->
      <!-- <div 
        class="verify-footer"
        v-if="
          verifyResultBo.identityVerifyResult == 2 || 
          verifyResultBo.entrustVerifyResult == 2
        "
      >
        <div class="btnBox">
          <el-button
            class="left-btn btn"
            size="mini"
            type="primary-icon-medium"
            @click="goPreviousStep()"
          >
            <span>{{ $t('basicLayout.btn')[0] }}</span>
          </el-button>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import {
  qrySupVerifyResult,
  getFaceIdentifyQrCode,
  supAgentEntrustVerify,
  refreshFaceIdentifyResult
} from "@/api/supRegister"
import { mapActions } from "vuex";
import { addUrlPerFix } from "@/utils";

export default {
  name: "ContactInformationVerify",
  data() {
    return {
      verifyResultBo: {},
      uploadUrl:
        this.$addUrlPerFix(process.env.VUE_APP_BASE_URL) +
        "/apis/sra/oss/users/signup/uploadFilePersNew",
      uploadData: {
        agentId: this.$router.history.current.query.a
      },
      headers: {
        Authorization: Cookies.get("access_token") || ""
      },
      countdown: 10,
      countdownTimer: null,
      failureCountdown: 10,
      failureCountdownTimer: null,
      qrcodeUrl: "",

      fileList: []
    };
  },
  created() {
    if (this.$route.path == "/maPerfectInfo/contactInformationVerify") {
      this.changeCheckPage(5);
    }
    if (Cookies.get("access_token") || this.$route.query.tempSupinfoId) {
      this.init();
    }
  },
  watch: {
    // "verifyResultBo.identityVerifyResult": {
    //   handler(val) {
    //     if (val === 2 && !this.failureCountdownTimer) {
    //       this.startFailureCountdown();
    //     } else if (val === 2 && !this.countdownTimer) {
    //       this.startCountdown();
    //     }
    //   },
    //   immediate: true
    // },
    // // 授权委托书上传状态
    // "verifyResultBo.entrustVerifyResult": {
    //   handler(val) {
    //     if (val === 2 && !this.failureCountdownTimer) {
    //       this.startFailureCountdown();
    //     } else if (val === 2 && !this.countdownTimer) {
    //       this.startCountdown();
    //     }
    //   },
    //   immediate: true
    // }
  },
  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
    if (this.failureCountdownTimer) {
      clearInterval(this.failureCountdownTimer);
    }
  },
  methods: {
    ...mapActions(["changeCheckPage"]),
    async init() {
      await qrySupVerifyResult({
        supId: this.$route.query.tempSupinfoId,
        tempOrFormalFlag: 0
      })
      .then(res => {
        if (res.data.code === "0") {
          this.verifyResultBo = res.data.data;
          // 人脸验证状态为0时，调用人脸验证接口
          if(this.verifyResultBo.fileBOList.length) {
            this.fileList = this.verifyResultBo.fileBOList.map((item, index) => ({
              uid: item.uploadId || `init-${index}`,
              name: item.fileName,
              url: item.fileUrl || item.downloadUrl,
              status: "success",
              size: item.fileSize,
              response: {
                data: [
                  {
                    uploadId: item.uploadId,
                    fileName: item.fileName,
                    downloadUrl: item.fileUrl || item.downloadUrl
                  }
                ]
              }
            }));
          }
          
          if(
            // this.verifyResultBo.verifyType == 2 && 
            (this.verifyResultBo.identityVerifyResult == null || 
            this.verifyResultBo.identityVerifyResult == 0 ||
            this.verifyResultBo.identityVerifyResult == 3)
          ){
            getFaceIdentifyQrCode({
              tempSupinfoId: this.$route.query.tempSupinfoId,
            })
            .then(res => {
              if (res.data.code === "0") {
                this.qrcodeUrl = res.data.data.qrCodeImageUrl || "";
                // this.qrcodeUrl = "data:image/png;base64,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";
              }
            })
          }
        }
      })
    },
    beforeUpload(file) {
      const fileName = file.name;
      const ext = fileName.split(".").pop().toLowerCase();
      const allowedExts = ["jpg", "jpeg", "png", "pdf"];
      if (!allowedExts.includes(ext)) {
        this.$message.error("仅支持上传图片或PDF格式文件");
        return false;
      }
      const isLt15M = file.size / 1024 / 1024 < 15;
      if (!isLt15M) {
        this.$message.error("文件大小不能超过15M");
        return false;
      }
      return true;
    },
    handleUploadSuccess(response, file, fileList) {
      if (response.code == "0") {
        this.$message.success("上传成功");
      } else {
        this.$message.error(response.message || "上传失败");
      }
      console.log(response, file, fileList, "====================");
      let data = response.data.map(item => {
        return {
          uploadId: item.uploadId,
          fileUrl: item.downloadUrl,
          fileName: item.fileName,
          fileSize: item.fileSize,
          uploadTime: item.updateTime,
          fileinfoType: 4
        }
      });
      supAgentEntrustVerify({
        tempSupinfoId: this.$route.query.tempSupinfoId,
        fileBOList: data
      })
      .then(res => { 
        if (res.data.code === "0") {
          console.log(res, "===010204");
        }
      })
    },
    handleUploadError() {
      this.$message.error("上传失败，请重试");
    },
    downloadTemplate() {
      // TODO: 下载委托书模版
      let uploadid = "10091289756";
      if (window.location.host.indexOf("test01") != -1) {
        uploadid = "10006201594";
      }
      const url =
        `${addUrlPerFix(
          process.env.VUE_APP_BASE_URL
        )}/apis/sra/reg/users/signup/downloadByUploadId?uploadId=` + uploadid;
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "编码导入模板.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    refreshVerify() {
      // TODO: 刷新认证结果
      refreshFaceIdentifyResult({
        tempSupinfoId: this.$route.query.tempSupinfoId,
        isShowLoading: true
      })
      .then(res => { 
        if (res.data.code === "0") {
          this.verifyResultBo = res.data.data;
        }
      })
    },
    startCountdown() {
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          // this.goNext();
        }
      }, 1000);
    },
    goNext() {
      // if (this.countdownTimer) {
      //   clearInterval(this.countdownTimer);
      // }
      this.$router.push({
        path: "/maPerfectInfo/productInformation",
        query: { tempSupinfoId: this.$route.query.tempSupinfoId }
      });
    },
    goPreviousStep() {
      this.$router.push({
        path: "/maPerfectInfo/contactInformation",
        query: { tempSupinfoId: this.$route.query.tempSupinfoId }
      });
    },
    // 委托书认证失败 重新上传委托书
    restUpLoad() {
      this.verifyResultBo.entrustVerifyResult = 0;
    },
    // 人脸认证失败 重新验证人脸
    restVerify() {
      getFaceIdentifyQrCode({
        tempSupinfoId: this.$route.query.tempSupinfoId,
        isShowLoading: true
      })
      .then(res => {
        if (res.data.code === "0") {
          this.qrcodeUrl = res.data.data.qrCodeImageUrl || "";
          // this.qrcodeUrl = "data:image/png;base64,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";
          if(this.qrcodeUrl) {
            this.verifyResultBo.identityVerifyResult = 0;
          }
        }
      })
    },
    startFailureCountdown() {
      this.failureCountdownTimer = setInterval(() => {
        this.failureCountdown--;
        if (this.failureCountdown <= 0) {
          clearInterval(this.failureCountdownTimer);
          this.goBack();
        }
      }, 1000);
    },
    goBack() {
      if (this.failureCountdownTimer) {
        clearInterval(this.failureCountdownTimer);
      }
      this.$router.push({
        path: "/maPerfectInfo/contactInformation",
        query: { tempSupinfoId: this.$route.query.tempSupinfoId }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.sign-content {
  width: 1180px;
  background: #ffffff;
  margin: 20px auto;
  padding: 40px 60px 50px;
  box-sizing: border-box;
  // min-height: 610px;
  height: auto !important;
}
.verifyOne {
  width: 100%;
  height: 100%;
  .verify-warning {
    text-align: center;
  }
  .verify-cotent {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.verify-one-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  text-align: center;
  margin-bottom: 12px;
}

.qrcode-box-large {
  width: 240px;
  height: 240px;
  border: 1px solid #dcdfe6;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;

  .qrcode-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .qrcode-placeholder {
    font-size: 16px;
    color: #909399;
  }
}

.scan-tip {
  font-size: 14px;
  color: #909399;
  text-align: center;
  margin-bottom: 15px;
}

.refresh-btn {
  width: 160px;
  height: 40px;
  margin-bottom: 20px;
  border: 1px solid #dcdfe6;
  background: #fff;
  color: #606266;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    color: #409eff;
    border-color: #409eff;
  }
}

/* 刷新认证结果按钮：红底白字，宽高参照上一步按钮 */
.refresh-result-btn {
  width: 240px;
  height: 40px;
  background: #FF142F;
  border: 1px solid #FF142F;
  color: #fff;

  &:hover {
    background: #FF142F;
    border-color: #FF142F;
    color: #fff;
    opacity: 0.9;
  }
}

.verify-warning {
  color: #ff142f;
  font-size: 14px;
  // text-align: center;
  margin-bottom: 20px;
}

.verify-container {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 0 40px;
  margin-bottom: 30px;
}

.verify-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
}

.verify-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
}

.verify-divider {
  width: 1px;
  height: 139px;
  background-color: #dcdfe6;
  margin: 82px 0 0;
  flex-shrink: 0;
}

.verify-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 12px;
  text-align: center;

  &.required::before {
    content: "*";
    color: #ff142f;
    margin-right: 4px;
  }
}

.qrcode-box {
  width: 180px;
  height: 180px;
  border: 1px solid #dcdfe6;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;

  .qrcode-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .qrcode-placeholder {
    font-size: 16px;
    color: #909399;
  }
}

/* 认证通过状态样式 */
.success-icon-wrapper {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #7ed321;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 40px auto 20px;

  i {
    font-size: 36px;
    color: #fff;
  }
}

.success-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #7ed321;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 30px auto 16px;

  i {
    font-size: 30px;
    color: #fff;
  }
}

.success-img {
  width: 120px;
  height: auto;
  object-fit: contain;
  display: block;
  margin: 30px auto 16px;
}

.success-img-large {
  width: 160px;
  margin: 40px auto 20px;
}

/* 认证通过图片+文字外框 */
.success-box {
  width: 186px;
  height: 186px;
  box-sizing: border-box;
  border: 1px solid #EFEFEF;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
}

.success-box .success-img {
  display: block;
  width: 120px;
  margin: 0;
  margin-bottom: 26px;
}

.success-box .success-text,
.success-box .success-title {
  margin: 0;
}

.success-text {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
  text-align: center;
}

.success-title {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
  text-align: center;
}

.countdown-tip {
  font-size: 14px;
  color: #606266;
  text-align: center;
  margin-bottom: 20px;
}

.next-btn {
  width: 160px;
  height: 40px;
  border: 1px solid #dcdfe6;
  background: #fff;
  color: #606266;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    color: #409eff;
    border-color: #409eff;
  }
}

/* 认证失败状态样式 */
.failure-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 35px auto 16px;

  i {
    font-size: 56px;
    color: #303133;
  }
}

.failure-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 30px auto 16px;

  i {
    font-size: 56px;
    color: #303133;
  }
}

.failure-text {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
  text-align: center;
  margin-bottom: 20px;
}

.failure-title {
  font-size: 22px;
  font-weight: bold;
  color: #303133;
  text-align: center;
  margin-bottom: 40px;
}

.failure-countdown-tip {
  font-size: 14px;
  color: #606266;
  text-align: center;
}
.verify-footer {
  text-align: center;

}
.upload-tip {
  font-size: 13px;
  margin-bottom: 10px;
}
.auth-upload {
  text-align: center;
  margin-bottom: 52px;
}
.no-fileInfo {
  height: 180px;
  width: 180px;
  border: 1px dashed #ccc;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.upload-icon-img {
  width: 60px;
  height: 60px;
  object-fit: contain;
}
.upload-text {
  color: #0089EF;
}
.download-template {
  cursor: pointer;
  color: #0089EF;
}

/* 扫描图标样式 */
.scan-icons {
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-bottom: 16px;
}

.scan-icon-item {
  width: 28px;
  height: 28px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
}
.wx {
  background-image: url('../../../../assets/images/wx.png');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
.qq {
  background-image: url('../../../../assets/images/qq.png');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
.zfb {
  background-image: url('../../../../assets/images/zfb.png');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}


.verifyRightTitle {
  margin-bottom: 20px;
}
.failure-reason {
  margin-bottom: 20px;
}

.btnBox {
  margin: 0px auto;
  width: 500px;
  text-align: center;
}
.btn {
  width: 240px;
  height: 40px;
  background: #FF142F;
  margin-bottom: 20px;
  span {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFangSC;
    font-weight: 600;
  }
}

</style>
